__webpack_public_path__ = PUBLIC_CONFIG.PUBLIC_PATH;

export {};
